export default function Price({
  price,
  annualPrice,
  annualDiscount = false,
}) {
  return (
    <>
      <div className="priceRow">
        <span className="priceAbbr">$</span>
        <span className="pricePerInterval">{price}</span>
        <span className="priceAbbrInterval">
          <span>USD/</span>
          <span>mo</span>
        </span>
      </div>
      {annualDiscount && (
        <>
          <div className="annualPrice">${annualPrice} USD/year</div>
          <div className="paymentPeriodNote">
            You save ${annualDiscount} a year
          </div>
        </>
      )}
    </>
  );
}
